import { Button } from "@gigpro/ui/Button";
import { cn } from "@gigpro/ui/tailwind/cn";
import type { PricingEnum } from "@sidegigllc/api/client";

interface HireFeeActionButtonsProps {
  onHireNow: () => void;
  /** Where the Jobs plan trial step plugs in: replaces onHireNow for a location that is not subscribed. */
  onStartTrial?: () => void;
  pricing?: PricingEnum;
  proFirstName?: string;
  variant?: "compact" | "detailed";
  disabled?: boolean;
  className?: string;
}

export const HireFeeActionButtons = ({
  onHireNow,
  onStartTrial,
  pricing,
  proFirstName,
  variant = "compact",
  disabled,
  className,
}: HireFeeActionButtonsProps) => {
  const hireLabel = proFirstName ? `Hire ${proFirstName}` : "Hire Now";
  const onHire = pricing === "not_subscribed" && onStartTrial ? onStartTrial : onHireNow;

  return (
    <Button
      variant="contained"
      size={variant === "detailed" ? "large" : "small"}
      className={cn("w-full", className)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onHire();
      }}
      disabled={disabled}
    >
      {hireLabel}
    </Button>
  );
};
HireFeeActionButtons.displayName = "HireFeeActionButtons";
